export default __webpack_public_path__ + "static/media/GreenDot.001b7ea3.svg";